<div class="wrapper">
  <img src="assets/images/illustration_state_error1.svg" alt="404"/>
  <h4 class="text-center font-weight-bold">
    {{ 'COMMON.page_not_found' | translate }}
  </h4>
</div>
